(function () {
  angular.module("app").controller("routeOptionModalController", [
    "$scope",
    "UserProvider",
    "$uibModalInstance",
    "alkModalService",
    "$timeout",
    "routeService",
    "routeCopy",
    "optionsUI",
    "subscriptionLevel",
    "isDefault",
    "conversionService",
    "routingProfile",
    "_",
    "defaultDimensions",
    "applicationSettingsService",
    "$location",
    "eventTracker",
    function routeOptionModalController(
      $scope,
      UserProvider,
      $uibModalInstance,
      alkModalService,
      $timeout,
      routeService,
      routeCopy,
      optionsUI,
      subscriptionLevel,
      isDefault,
      conversionService,
      routingProfile,
      _,
      defaultDimensions,
      applicationSettingsService,
      $location,
      eventTracker
    ) {
      var vm = this;

      vm.defaultDimensions = defaultDimensions;
      vm.optionsUI = optionsUI;
      vm.routeCopy = routeCopy;
      vm.subscriptionLevel = subscriptionLevel;
      vm.isDefault = isDefault;
      vm.isAlertShowing = false;
      vm.showAlert = () => (vm.isAlertShowing = true);
      vm.hideAlert = () => (vm.isAlertShowing = false);

      vm.prepareForSave = prepareForSave;
      vm.changeElevationDiscouraged = changeElevationDiscouraged;
      vm.changeGovernorSpeedLimit = changeGovernorSpeedLimit;
      vm.depTypeChanged = depTypeChanged;
      vm.vehicleTypeChanged = vehicleTypeChanged;

      vm.resetToDefaults = resetToDefaults;
      vm.goToApplicationSettings = goToApplicationSettings;
      vm.saveAsDefaults = saveAsDefaults;
      vm.ok = ok;
      vm.close = close;
      vm.userCfg = {
        classicSearchView:
          applicationSettingsService.getUserCfg("classicSearchView"),
        includePOI: applicationSettingsService.getUserCfg("includePOI"),
      };

      initializeLocalOptions();
      var disableClassOverrides;
      vm.updateClassOverrides = updateClassOverrides;
      function updateClassOverrides() {
        if (
          vm.localOptions.lengthFeet > 48 ||
          vm.localOptions.widthEnglish > 96
        ) {
          vm.routeCopy.options.classOverrides = 3;  
          disableClassOverrides = true;  
        } else {
          vm.routeCopy.options.classOverrides = 0;
          disableClassOverrides = false;
        }
      }
     
      vm.getDisabledOption = getDisabledOption
      function getDisabledOption() {
        return disableClassOverrides;
      }
      

      function initializeLocalOptions() {
        vm.localOptions = {};
        vm.localOptions.name = vm.routeCopy.name;
        // classOverrides(3) means nationalNetwork + fiftyThreeFoot. classOverrides(0) means None.
        vm.localOptions.nationalNetwork =
          vm.routeCopy.options.classOverrides === 3 ? true : false;
        vm.localOptions.fiftyThreeFoot =
          vm.routeCopy.options.classOverrides === 3 ? true : false;
        vm.region = UserProvider.getUser().region;
        //if (uiArrDepSelection !== undefined){
        //vm.depTypeChanged();
        //}
        // vm.routeCopy.options.useTraffic=false;
        // if elevation limit is not null, than it is discouraged
        vm.localOptions.isElevationDiscouraged =
          vm.routeCopy.options.elevLimit != null;
        vm.localOptions.elevationLimit =
          vm.routeCopy.options.elevLimit ||
          (vm.routeCopy.options.trkUnits === 0
            ? vm.defaultDimensions.def.limit.elevationEnglish
            : vm.defaultDimensions.def.limit.elevationMetric);
        vm.localOptions.isGovernorSpeedLimit =
          vm.routeCopy.options.governorSpeedLimit != null;
        vm.localOptions.governorSpeedLimit =
          vm.routeCopy.options.governorSpeedLimit ||
          (vm.routeCopy.options.trkUnits === 0
            ? vm.defaultDimensions.def.limit.governorSpeedEnglish
            : vm.defaultDimensions.def.limit.governorSpeedMetric);

        var height;
        var length;

        if (vm.routeCopy.options.trkUnits === 0) {
          // units are in feet/inches
          height = conversionService.stringToFeetInches(
            vm.routeCopy.options.trkHeight
          );
          length = conversionService.stringToFeetInches(
            vm.routeCopy.options.trkLength
          );

          vm.localOptions.heightFeet = height[0];
          vm.localOptions.heightInches = height[1];
          vm.localOptions.lengthFeet = length[0];
          vm.localOptions.lengthInches = length[1];
          vm.localOptions.heightMeters = conversionService.feetInchesToMeters(
            height[0],
            height[1],
            4
          );
          vm.localOptions.lengthMeters = conversionService.feetInchesToMeters(
            length[0],
            length[1],
            4
          );
          vm.localOptions.widthEnglish = conversionService.stringToTotalInches(
            vm.routeCopy.options.trkWidth
          );
          vm.localOptions.widthMetric = conversionService.inchesToMeters(
            vm.localOptions.widthEnglish,
            2
          );
          vm.localOptions.weightPounds = vm.routeCopy.options.trkWeight;
          vm.localOptions.weightKilograms = conversionService.poundsToKilograms(
            vm.routeCopy.options.trkWeight
          );

          if (vm.routeCopy.options.classOverrides === 3 && (vm.localOptions.lengthFeet > 48 ||
            vm.localOptions.widthEnglish > 96)) {
            disableClassOverrides = true;
          }
          else {
            disableClassOverrides = false;
          }


        } else {
          // units are in meters
          height = conversionService.metersToFeetInches(
            vm.routeCopy.options.trkHeight
          );
          length = conversionService.metersToFeetInches(
            vm.routeCopy.options.trkLength
          );

          vm.localOptions.heightFeet = height[0];
          vm.localOptions.heightInches = height[1];
          vm.localOptions.lengthFeet = length[0];
          vm.localOptions.lengthInches = length[1];
          vm.localOptions.heightMeters = parseFloat(
            vm.routeCopy.options.trkHeight
          );
          vm.localOptions.lengthMeters = parseFloat(
            vm.routeCopy.options.trkLength
          );
          vm.localOptions.widthEnglish = conversionService.metersToInches(
            vm.routeCopy.options.trkWidth
          );
          vm.localOptions.widthMetric = vm.routeCopy.options.trkWidth;
          vm.localOptions.weightPounds = conversionService.kilogramsToPounds(
            vm.routeCopy.options.trkWeight
          );
          vm.localOptions.weightKilograms = vm.routeCopy.options.trkWeight;
        }

        //additional columns for EU region (saved in local storage currently)
        if (vm.region === "EU") {
          var trlMaxHt;

          vm.EUOptions = vm.routeCopy.options.EUOptions;
          vm.localOptionsEU = {};
          if (vm.routeCopy.options.trkUnits === 0) {
            trlMaxHt = conversionService.stringToFeetInches(
              vm.EUOptions.trlMaxHt
            );

            vm.localOptionsEU.heightFeet = trlMaxHt[0];
            vm.localOptionsEU.heightInches = trlMaxHt[1];
            vm.localOptionsEU.heightMeters =
              conversionService.feetInchesToMeters(trlMaxHt[0], trlMaxHt[1], 4);
            vm.localOptionsEU.weightPounds = vm.EUOptions.trlMaxWt;
            vm.localOptionsEU.weightKilograms =
              conversionService.poundsToKilograms(vm.EUOptions.trlMaxWt);
          } else {
            trlMaxHt = conversionService.metersToFeetInches(
              vm.EUOptions.trlMaxHt
            );

            vm.localOptionsEU.heightFeet = trlMaxHt[0];
            vm.localOptionsEU.heightInches = trlMaxHt[1];
            vm.localOptionsEU.heightMeters = parseFloat(vm.EUOptions.trlMaxHt);
            vm.localOptionsEU.weightPounds =
              conversionService.kilogramsToPounds(vm.EUOptions.trlMaxWt);
            vm.localOptionsEU.weightKilograms = vm.EUOptions.trlMaxWt;
          }
        }
      }

      function prepareForSave() {
        vm.routeCopy.options.elevLimit = vm.localOptions.isElevationDiscouraged
          ? vm.localOptions.elevationLimit
          : null;
        vm.routeCopy.options.governorSpeedLimit = vm.localOptions
          .isGovernorSpeedLimit
          ? vm.localOptions.governorSpeedLimit
          : null;

        if (vm.routeCopy.options.trkUnits === 0) {
          vm.routeCopy.options.trkHeight = conversionService.feetInchesToString(
            [vm.localOptions.heightFeet, vm.localOptions.heightInches]
          );
          vm.routeCopy.options.trkLength = conversionService.feetInchesToString(
            [vm.localOptions.lengthFeet, vm.localOptions.lengthInches]
          );
          vm.routeCopy.options.trkWidth = conversionService.totalInchesToString(
            vm.localOptions.widthEnglish,
            true
          );
          vm.routeCopy.options.trkWeight = vm.localOptions.weightPounds;
        } else {
          vm.routeCopy.options.trkHeight = vm.localOptions.heightMeters;
          vm.routeCopy.options.trkLength = vm.localOptions.lengthMeters;
          vm.routeCopy.options.trkWidth = vm.localOptions.widthMetric;
          vm.routeCopy.options.trkWeight = vm.localOptions.weightKilograms;
        }

        // addtional columns for EU region
        if (vm.region === "EU") {
          if (vm.routeCopy.options.trkUnits === 0) {
            vm.EUOptions.trlMaxHt = conversionService.feetInchesToString([
              vm.localOptionsEU.heightFeet,
              vm.localOptionsEU.heightInches,
            ]);
            vm.EUOptions.trlMaxWt = vm.localOptionsEU.weightPounds;
          } else {
            vm.EUOptions.trlMaxHt = vm.localOptionsEU.heightMeters;
            vm.EUOptions.trlMaxWt = vm.localOptionsEU.weightKilograms;
          }
          vm.routeCopy.options.EUOptions = vm.EUOptions;
        }
      }

      function changeElevationDiscouraged() {
        if (!vm.localOptions.isElevationDiscouraged) {
          vm.routeCopy.options.elevLimit = null;
        }
      }

      function changeGovernorSpeedLimit() {
        if (!vm.localOptions.isGovernorSpeedLimit) {
          vm.routeCopy.options.governorSpeedLimit = null;
        }
      }

      function depTypeChanged() {
        if (vm.routeCopy.uiArrDepSelection.type === "now") {
          vm.routeCopy.options.useTraffic = true;
        } else {
          vm.routeCopy.options.useTraffic = false;
        }
      }

      function vehicleTypeChanged() {
        // when vehicle type changes, set the default values for all fields

        var vehicle;
        var max = vm.defaultDimensions.max;
        var min = vm.defaultDimensions.min;

        if (vm.routeCopy.options.vehicleType === 0) {
          vehicle = vm.defaultDimensions.def.truck;
        } else if (vm.routeCopy.options.vehicleType === 1) {
          vehicle = vm.defaultDimensions.def.light;
        } else if (vm.routeCopy.options.vehicleType === 2) {
          vehicle = vm.defaultDimensions.def.car;
        }

        if (vm.region === "EU") {
          vm.EUOptions.hasTrailer =
            vm.routeCopy.options.vehicleType === 2 ? false : true;
        }

        vm.routeCopy.options.trkAxles = vehicle.axles;

        // the english units are the default values, they do not need to be run through bounds to make sure they are within the limit.
        vm.localOptions.heightFeet = conversionService.feet(vehicle.height);
        vm.localOptions.heightInches = conversionService.inches(vehicle.height);
        vm.localOptions.lengthFeet = conversionService.feet(vehicle.length);
        vm.localOptions.lengthInches = conversionService.inches(vehicle.length);
        vm.localOptions.widthEnglish = vehicle.width;
        vm.localOptions.weightPounds = vehicle.weight;

        // conversion is being done, make sure to keep the values within the correct max/min and correct number of decimal places.
        vm.localOptions.heightMeters = conversionService.bounds(
          min.heightMetric,
          max.heightMetric,
          conversionService.feetInchesToMeters(
            vm.localOptions.heightFeet,
            vm.localOptions.heightInches,
            4
          )
        ); // ensure we stay within bounds because of rounding
        vm.localOptions.lengthMeters = conversionService.bounds(
          min.lengthMetric,
          max.lengthMetric,
          conversionService.feetInchesToMeters(
            vm.localOptions.lengthFeet,
            vm.localOptions.lengthInches,
            4
          )
        );
        vm.localOptions.widthMetric = conversionService.inchesToMeters(
          vehicle.width,
          2
        );
        vm.localOptions.weightKilograms = conversionService.bounds(
          min.weightMetric,
          max.weightMetric,
          conversionService.poundsToKilograms(vehicle.weight, 2)
        );
      }

      function resetToDefaults() {
        vm.routeCopy.options = routingProfile.getSystemDefaultOptions();
        vm.userCfg = {
          classicSearchView:
            applicationSettingsService.getDefaultUserCfg("classicSearchView"),
          includePOI:
            applicationSettingsService.getDefaultUserCfg("includePOI"),
        };

        $scope.$broadcast("resetAFSelection");
        initializeLocalOptions();
      }

      function goToApplicationSettings() {
        if (!$scope.routeOptionsForm.$pristine) {
          alkModalService
            .show(
              {
                size: "sm",
              },
              {
                headerText: "Exit Route Options",
                bodyText:
                  "Are you sure you want to exit without saving your changes?",
              }
            )
            .then(function () {
              vm.close();
              $location.url("/applicationSettings");
            });
        } else {
          vm.close();
          $location.url("/applicationSettings");
        }
      }

      function saveAsDefaults() {
        vm.prepareForSave();
        routingProfile.setDefaultOptions(vm.routeCopy.options);
        vm.showAlert();
        $timeout(vm.hideAlert, 2000);
      }

      function ok() {
        vm.prepareForSave();
        if (vm.isDefault) {
          applicationSettingsService.updateUserCfg(vm.userCfg);
        }
        $uibModalInstance.close(vm.routeCopy);
        eventTracker.track(eventTracker.EVENTS.RT_OPTIONS, {
          options: vm.routeCopy.options,
        });
      }

      function close() {
        $uibModalInstance.dismiss("cancel");
      }

      /////////////////////////////////////////////////////////////////
      // Event handlers section
      /////////////////////////////////////////////////////////////////

      $scope.$watch("vm.routeCopy.options.classOverrides", function () {
        if (vm.routeCopy.options.classOverrides === 0) {
          vm.localOptions.nationalNetwork = false;
          vm.localOptions.fiftyThreeFoot = false;
        } else {
          vm.localOptions.nationalNetwork = true;
          vm.localOptions.fiftyThreeFoot = true;
        }
      });

      // if the elevation discouraged is not enabled and the elevation limit is not a valid number, set it to the default.
      $scope.$watch("vm.localOptions.isElevationDiscouraged", function () {
        if (
          vm.localOptions.isElevationDiscouraged === false &&
          !vm.localOptions.elevationLimit
        ) {
          vm.localOptions.elevationLimit =
            vm.routeCopy.options.trkUnits === 0
              ? vm.defaultDimensions.def.limit.elevationEnglish
              : vm.defaultDimensions.def.limit.elevationMetric;
        }
      });

      // if the gorvernor speed is not enabled and the gorvernor speed limit is not a valid number, set it to the default.
      $scope.$watch("vm.localOptions.isGovernorSpeedLimit", function () {
        if (
          vm.localOptions.isGovernorSpeedLimit === false &&
          !vm.localOptions.governorSpeedLimit
        ) {
          vm.localOptions.governorSpeedLimit =
            vm.routeCopy.options.trkUnits === 0
              ? vm.defaultDimensions.def.limit.governorSpeedEnglish
              : vm.defaultDimensions.def.limit.governorSpeedMetric;
        }
      });
    },
  ]);
})();



// WEBPACK FOOTER //
// ./app/route/routeOptions.controller.js